<script setup>
import {onUpdated, ref} from "vue";
import {formatDate} from "@/plugins/dayjs";

const selectedAge = ref('');
const emits = defineEmits(['set_age']);
const props = defineProps(['ages'])
const tmpAges = ref()
const fn_selectAge = (e)=>{
  let age = e.target.dataset.id;
  const divAge = document.querySelector("#ageList");
  const divAgeChild = divAge.children;
  for(let i =0 ; i<divAgeChild.length ; i++){
    divAgeChild[i].classList.replace("selectedAge","age");
    if(age === divAgeChild[i].dataset.id){
      divAgeChild[i].classList.replace('age', 'selectedAge');
    }
  }
  selectedAge.value = age
  emits("set_age", age)
}

onUpdated(()=>{
  tmpAges.value = props.ages;
})

</script>

<template>
  <div class="ageList" id="ageList" >
    <template v-for="(age, i) in ages" :key="i">
      <div v-if="i === 0" :data-id="age.ageId" class="selectedAge"  @click="fn_selectAge" >
        {{ age.ageTitle }}
        <br/>
        {{ formatDate(age.startDt, 'YYYY-MM-DD') }} ~ {{ formatDate(age.endDt, 'YYYY-MM-DD') }}
      </div>
      <div v-else :data-id="age.ageId" class="age"  @click="fn_selectAge" >
        {{ age.ageTitle }}
        <br/>
        {{ formatDate(age.startDt, 'YYYY-MM-DD') }} ~ {{ formatDate(age.endDt, 'YYYY-MM-DD') }}
      </div>

    </template>
  </div>
</template>

<style scoped>
  .ageList{
    height: 67vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .age{
    height: 6vh;
    width: 100%;
    display: flex;
    border-bottom: 1px solid #C7C7C7;
    justify-content: center;
    align-items: center;
    cursor : pointer;
    flex-direction: column;
    text-align: center;

  }
  .selectedAge{
    height: 6vh;
    width: 100%;
    display: flex;
    border-bottom: 1px solid #C7C7C7;
    justify-content: center;
    align-items: center;
    background: #D4F2FF;
    font-weight: bold;
    flex-direction: column;
    text-align: center;

  }

</style>